module.exports = __webpack_public_path__ + "img/icon_chat_gradient.a04544b.png";